export type SocialConnectionSource = "Webhook" | "Sync" | "AutoUnlink";

export type SocialConnectionSortColumn =
    | "lastDisconnectedAt"
    | "userName"
    | "email"
    | "connectedCount"
    | "disconnectedCount";

export type SortDirection = "asc" | "desc";

// "all" lists every user with an Ayrshare profile; "issues" is the chase-up list.
export type SocialConnectionStatusFilter = "all" | "issues";

export interface DisconnectedAccount {
    platform: string;
    disconnectedAt: string;
    source: SocialConnectionSource;
    displayName?: string;
    username?: string;
}

export interface SocialPausePlatformCount {
    platform: string;
    count: number;
}

export interface SocialConnectionRow {
    userId: string;
    userName: string;
    email: string;
    phoneNumber: string;
    connectedPlatforms: string[];
    disconnectedAccounts: DisconnectedAccount[];
    socialPausePosts: SocialPausePlatformCount[];
    totalSocialPausePosts: number;
    lastDisconnectedAt: string | null;
}

export interface PaginatedSocialConnections {
    data: SocialConnectionRow[];
    total: number;
    page: number;
    totalPages: number;
}

export interface SocialConnectionMetrics {
    totalUsers: number;
    connectedAccounts: number;
    usersWithDisconnectedAccounts: number;
    disconnectedAccounts: number;
    usersWithSocialPausePosts: number;
    socialPausePosts: number;
}

// Ayrshare's platform keys, which is what the API returns for every platform field.
export const SOCIAL_CONNECTION_PLATFORMS = [
    "facebook",
    "instagram",
    "twitter",
    "linkedin",
    "pinterest",
    "gmb",
    "youtube",
    "tiktok",
] as const;

const PLATFORM_LABELS: Record<string, string> = {
    facebook: "Facebook",
    instagram: "Instagram",
    twitter: "X (Twitter)",
    linkedin: "LinkedIn",
    pinterest: "Pinterest",
    gmb: "Google Business",
    youtube: "YouTube",
    tiktok: "TikTok",
};

export const formatPlatform = (platform: string): string =>
    PLATFORM_LABELS[platform] ??
    platform.charAt(0).toUpperCase() + platform.slice(1);

// logo-getter keys Google Business as "google"; Ayrshare calls it "gmb".
export const platformIconKey = (platform: string): string =>
    platform === "gmb" ? "google" : platform;
